import React, { useContext, useEffect, useState } from 'react';
import { navigate } from 'gatsby';
import { globalHistory } from '@gatsbyjs/reach-router';
import ServiceFactory from '../services/service-factory';
import { SummaryHeader } from '../header';
import ConfirmationFooter from '../footer';
import NpafFooter from '../npaf';
import { FlowRouteProps } from '../../../flow/flow';
import { ResponseData } from '../../../../hoc/context/api';
import { ModalWithButtons, RichText } from '../../../../hoc/components';
import context from '../../../../hoc/context/product/context';
import { enrollmentContext } from '../../../../hoc/context/enrollment/enrollment-context';
import { EnrollmentLayout } from '../../../../hoc/components/layout/enrollment-layout';

function EnrollmentConfirmation({ location, flow }: FlowRouteProps) {
	const ctxt = useContext(context);
	const enrollmentCtxt = useContext(enrollmentContext);
	const [showModal, setShowModal] = useState(false);
	const alertUser = (e: BeforeUnloadEvent) => {
		e.preventDefault();
		e.returnValue = '';
	};

	const enrollments = enrollmentCtxt.enrollmentResponse.data.map(
		(enrollmentData: ResponseData) => {
			return {
				data: enrollmentData.card,
				state: enrollmentData.state,
				service: ctxt.json.services?.find(
					(service) => service?.name === enrollmentData?.service
				),
			};
		}
	);
	enrollments.sort((a, b) => {
		return (
			ctxt.json.services?.findIndex(
				(service) => service.name === a.service?.name
			) -
			ctxt.json.services?.findIndex(
				(service) => service.name === b.service?.name
			)
		);
	});

	useEffect(() => {
		const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
		const eventName = isSafari ? 'pagehide' : 'beforeunload';
		window.addEventListener(eventName, alertUser);
		return () => {
			window.removeEventListener(eventName, alertUser);
		};
	}, []);

	useEffect(() => {
		return globalHistory.listen((historyObject) => {
			if (
				historyObject.location.hash !== '#importantsafetyinformation' &&
				historyObject.action === 'POP'
			) {
				setShowModal(true);
				navigate(location?.pathname!);
			}
		});
	}, [location]);

	//FIXME change pizza_header_fto to banner.staticTitle
	//FIXME change pizza_header to banner.title
	return (
		<>
			<EnrollmentLayout
				label={ctxt.json.pages.confirmation.label}
				isBackButton={false}
				mlrVersion={ctxt.json.pages.confirmation.mlrVersion}
				title={
					enrollmentCtxt.isStatic(ctxt)
						? ctxt.json.pages.confirmation.pizzaHeaderFto
						: ctxt.json.pages.confirmation.pizzaHeader
				}>
				<div
					data-testid="component-confirmation-wrapper"
					className="flex flex-col gap-12 lg:gap-24 max-w-4xl mx-auto">
					<SummaryHeader parsedData={enrollments} />
					{enrollments?.map((service, index) => {
						return (
							<ServiceFactory
								key={`servicefactory-${index}`}
								status={service.state!}
								service={service.service!}
								data={service.data}
							/>
						);
					})}
					<ConfirmationFooter />
					<NpafFooter />
				</div>
			</EnrollmentLayout>
			<ModalWithButtons
				onClose={() => setShowModal(false)}
				open={showModal}
				primaryButton={{
					text: ctxt.json.pages.confirmation.leavepage,
					function: () => {
						flow.restart();
					},
				}}
				secondaryButton={{
					text: ctxt.json.pages.confirmation.cancel,
					function: () => {
						setShowModal(false);
					},
				}}
				title={ctxt.json.pages.confirmation.beforeYouLeave}>
				<p>
					<RichText html={ctxt.json.pages.confirmation.beforeYouLeaveContent} />
				</p>
				<p className="mt-4">
					<RichText
						html={ctxt.json.pages.confirmation.beforeYouLeaveContentphoneCall}
					/>
				</p>
			</ModalWithButtons>
		</>
	);
}

export default EnrollmentConfirmation;
